import { keys, addIndex, map } from 'ramda'

export const getCategories = keys

export const mapIndexed = addIndex(map)
